import { createFileRoute, Link } from '@tanstack/react-router'
import { countries, regions, type Region } from '@/lib/seo/countries'

export const Route = createFileRoute('/online-poker/')({
  head: () => ({
    meta: [
      {
        title: 'Online Poker by Country | Powka',
      },
      {
        name: 'description',
        content:
          'Explore online poker culture, laws, and communities across the United States and countries worldwide.',
      },
    ],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  const byRegion = regions.reduce<Record<Region, typeof countries>>(
    (acc, region) => {
      acc[region] = countries.filter((c) => c.region === region)
      return acc
    },
    {} as Record<Region, typeof countries>,
  )

  return (
    <div className="max-w-4xl mx-auto px-6 py-16">
      <h1 className="text-3xl font-bold mb-2">Online Poker</h1>
      <p className="text-muted-foreground mb-12">
        Poker is played by millions of people around the world. Explore the
        communities, culture, and cities that make each country unique.
      </p>

      <div className="space-y-12">
        {regions.map((region) => {
          const regionCountries = byRegion[region]
          if (!regionCountries.length) return null
          return (
            <div key={region}>
              <h2 className="text-lg font-semibold mb-4">{region}</h2>
              <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
                {regionCountries.map((country) => (
                  <Link
                    key={country.slug}
                    to="/online-poker/countries/$country"
                    params={{ country: country.slug }}
                    className="rounded-md border px-4 py-3 text-sm font-medium hover:bg-secondary/50 transition-colors"
                  >
                    {country.name}
                  </Link>
                ))}
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}
